import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center mb-6">
              <video src="/assets/logo.gif.mp4" poster="/assets/gec-logo.png" className="h-16 w-auto rounded-lg bg-white object-contain p-1" width="220" height="166" autoPlay loop muted playsInline aria-label="GEC logo" />
            </div>
            <p className="text-gray-400 mb-6">
              Your trusted partner for global education opportunities. We help students achieve their dreams of studying abroad.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/courses" className="text-gray-400 hover:text-white transition-colors">Courses</Link></li>
              <li><Link to="/colleges" className="text-gray-400 hover:text-white transition-colors">Colleges & Universities</Link></li>
              <li><Link to="/events" className="text-gray-400 hover:text-white transition-colors">Events</Link></li>
              <li><Link to="/consultation" className="text-gray-400 hover:text-white transition-colors">Free Consultation</Link></li>
              <li><Link to="/delegate-meetings" className="text-gray-400 hover:text-white transition-colors">Delegate Meetings</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Our Services</h3>
            <ul className="space-y-3">
              <li><span className="text-gray-400">University Selection</span></li>
              <li><span className="text-gray-400">Application Assistance</span></li>
              <li><span className="text-gray-400">Visa Guidance</span></li>
              <li><span className="text-gray-400">Scholarship Support</span></li>
              <li><span className="text-gray-400">Test Preparation</span></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-blue-400 mt-1 mr-3"></i>
                <span className="text-gray-400">
                  GEC Head Office<br />
                  Kaloor, Cochin<br />
                  Kerala, India
                </span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-blue-400 mr-3"></i>
                <span className="text-gray-400">+91 9020 500 700</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-blue-400 mr-3"></i>
                <span className="text-gray-400">info@gec.edu</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
            <p className="text-gray-400 text-sm">
              © 2024 GEC Educational Consultancy. All rights reserved.
            </p>
            <Link
              to="/terms"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
